import { render, staticRenderFns } from "./StudentProfileDetailDialog.vue?vue&type=template&id=5bae22f2"
import script from "./StudentProfileDetailDialog.vue?vue&type=script&lang=js"
export * from "./StudentProfileDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports